import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import {Button, Col, Container, Row, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import * as yup from "yup";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../services/store/store";
import {handleUserCreated} from "../../../services/store/reducers/session/slice";
import {UserService} from "../../../services/api/UserService";
import ErrorText from "../../../components/ErrorText";

interface Props {

}

const RegisterCreateProfile = ({}: Props) => {

    const { createUser } = UserService();

    const dispatch = useDispatch<AppDispatch>();

    const [errMsg, setErrMsg] = useState<string>();
    const [profileCreating, setProfileCreating] = useState(false);

    const schema = yup.object().shape({
        firstName: yup.string().required("First name is required"),
        lastName: yup.string().required("Last name is required"),
    });

    useEffect(() => setProfileCreating(false), []);

    const submitForm = async (values: any) => {
        if (profileCreating) {
            return;
        }

        setProfileCreating(true);
        setErrMsg(undefined);

        const resp = await createUser(values.firstName, values.lastName);

        if (resp.error) {
            setErrMsg(resp.error.message);
            setProfileCreating(false);
            return;
        }

        if (!resp.user) {
            setProfileCreating(false);
            return;
        }

        setProfileCreating(false);
        dispatch(handleUserCreated(resp.user));
    };

    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <span className={"heading"}>Create Profile</span>
                </div>

                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        firstName: "",
                        lastName: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <Form
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Row>
                                <Col>
                                    <Form.Label column={'lg'}>First Name</Form.Label>
                                    <Form.Group controlId="detailsForm.FirstName">
                                        <Form.Control
                                            className="onboarding_input"
                                            type="text"
                                            name="firstName"
                                            placeholder="First Name"
                                            value={values.firstName}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <Form.Label column={'lg'}>Last Name</Form.Label>
                                    <Form.Group controlId="detailsForm.LastName">
                                        <Form.Control
                                            className="onboarding_input"
                                            type="text"
                                            name="lastName"
                                            placeholder="Last Name"
                                            value={values.lastName}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            {errMsg && <ErrorText>{errMsg}</ErrorText>}

                            {!profileCreating && <Button type="submit" disabled={profileCreating} className={"forgotEmailConfirm_submitBtn"}>
                                CREATE
                            </Button>}
                            {profileCreating && <Button disabled={profileCreating} onClick={() => {}} className={"forgotEmailConfirm_submitBtn"}>
                                <Spinner animation={"border"}/>
                            </Button>}
                        </Form>
                    )}
                </Formik>
            </Container>
        </div>
    )
}

export default RegisterCreateProfile;